const translation = {
  daysInWeek: {
    Mon: 'Мой',
    Tue: 'Вторник',
    Sat: 'Суббота',
    Sun: 'Солнце',
    Thu: 'Четверг',
    Wed: 'Сряда',
    Fri: 'Свободно',
  },
  months: {
    March: 'Март',
    May: 'Май',
    April: 'Апрель',
    July: 'Июль',
    January: 'Январь',
    August: 'Август',
    December: 'Декабрь',
    February: 'Февраль',
    September: 'Сентябрь',
    October: 'Октябрь',
    June: 'Июнь',
    November: 'Ноябрь',
  },
  operation: {
    ok: 'Хорошо',
    pickDate: 'Выберите дату',
    now: 'Теперь',
    cancel: 'Отмена',
  },
  title: {
    pickTime: 'Выберите время',
  },
  defaultPlaceholder: 'Выберите время...',
}

export default translation
